import { createTypesenseEntitySearchAdapter } from "./createTypesenseEntitySearchAdapter";
import { createUniversalSearchModule } from "./createUniversalSearchModule";

export const universalSearch = createUniversalSearchModule({
  entitySearch: createTypesenseEntitySearchAdapter(),
});

export { createTypesenseEntitySearchAdapter, createUniversalSearchModule };
